import React from 'react';
import { useTranslation, Trans } from 'react-i18next';
import { centsToDollarsNumber } from '../../lib/util';
import ConfirmModal from '../../components/modals/ConfirmModal';
import styles from '../ManageSubscription/styles/SubscriptionContainer.module.scss';

interface IRenewAndSaveConfirmationModalProps {
  earlyRenewalSuggestedTermEnd: string;
  earlyRenewalChargeAmountCents: number;
  termLengthMonths: number;

  // IConfirmModalProps
  trigger: JSX.Element;
  onAccept?: () => void;
  onDecline?: () => void;
}

export default function RenewAndSaveConfirmationModal({
  earlyRenewalSuggestedTermEnd,
  earlyRenewalChargeAmountCents,
  termLengthMonths,
  trigger,
  onAccept = () => {},
  onDecline = () => {},
}: IRenewAndSaveConfirmationModalProps) {
  const { t } = useTranslation();
  return (
    <ConfirmModal
      trigger={trigger}
      body={
        <>
          <h3>{t('confirm_renewal')}</h3>
          <br />
          <p>
            <Trans
              i18nKey="you_will_be_charged_amount_now_and_membership_will_extend"
              values={{
                amount: centsToDollarsNumber(earlyRenewalChargeAmountCents),
                months: termLengthMonths,
                date: earlyRenewalSuggestedTermEnd,
              }}
              components={{
                amount: <span className={styles.emphasize} />,
                date: <span className={styles.emphasize} />,
              }}
            />
          </p>
        </>
      }
      acceptText={t('confirm')}
      declineText={t('go_back')}
      onAccept={() => {
        onAccept();
      }}
      onDecline={() => {
        onDecline();
      }}
    />
  );
}
